<template>
  <div class="wrapper">
    <div v-if="controltype === 'dropdown'">
      <div class="md-layout">
        <div class="md-layout-item md-size-80">
          <el-select
            @change="onSelect"
            class="select-primary"
            v-model="answer.id"
            placeholder="Select"
          >
            <el-option
              class="select-primary"
              v-for="item in answers"
              :key="item.id"
              :label="langtext(item.answer)"
              :value="item.id"
              >{{ langtext(item.answer) }}
            </el-option>
          </el-select>
        </div>
      </div>
    </div>
    <div v-if="controltype === 'singleselect' || controltype === 'multiselect'">
      <div class="md-layout" v-for="item in answers" :key="item.id">
        <div class="md-layout-item md-size-100" :style="'height: ' + (item.answer.length > 200 ? '130px' : (item.answer.length > 130 ? '110px' : (item.answer.length > 100 ? '90px' : (item.answer.length > 60 ? '70px' : 'auto'))))">
          <div v-if="controltype === 'singleselect'">
            <md-radio
              @change="onRadioClick(item.id)"
              :label="item.answer"
              :value="true"
              v-model="item.answerstatus"
              >{{ langtext(item.answer) }}</md-radio
            >
          </div>
          <div v-else>
            <md-checkbox @change="onChange" v-model="item.answerstatus">{{
              langtext(item.answer)
            }}</md-checkbox>
          </div>
        </div>
      </div>
    </div>
    <answer-required-field v-if="!isvalid"></answer-required-field>
  </div>
</template>

<script>
import AnswerRequiredField from "./AnswerRequiredField";
import { Select, Option } from "element-ui";
import Mixins from "@/plugins/basicMixins";
import { GetPublicAnswers } from "../../services/react";
export default {
  name: "answer-select",
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    AnswerRequiredField,
  },
  mixins: [Mixins.HeaderImage],
  props: {
    linkid: String,
    controltype: String,
    required: Boolean,
    id: String,
  },
  data() {
    return {
      answers: [],
      answer: {},
      selectedanswer: "",
      isvalid: true,
    };
  },
  methods: {
    value() {
      let value = [];
      let order = [];
      if (this.controltype === "dropdown") {
        if (this.answer.id) {
          value.push(this.answer.id);
          order.push(this.answer.orderindex);
        }
      } else {
        this.answers.forEach(function (item) {
          if (item.answerstatus) {
            value.push(item.id);
            order.push(item.orderindex);
          }
        });
      }
      return { value: value, order: order };
    },
    isNegative() {
      return this.controltype === "dropdown"
        ? this.answers.filter((c) => c.id === this.answer.id)[0].negative === 1
        : this.answers.filter((c) => c.negative === 1 && c.answerstatus)
            .length > 0;
    },
    isValid() {
      return this.required
        ? this.value().value.length > 0
          ? true
          : false
        : true;
    },
    validate() {
      this.isvalid = this.isValid();
      return this.isvalid;
    },
    onChange() {
      this.isvalid = true;
      this.$emit("changed", this.value());
    },
    onRadioClick(id) {
      this.answers.forEach(function (item) {
        item.answerstatus = item.id === id;
      });
      this.isvalid = true;
      this.$emit("changed", this.value());
    },

    getAnswers() {
      this.isLoading = true;
      GetPublicAnswers(this.id, this.linkid).then((response) => {
        if (response.data.result) {
          this.answers = response.data.result;
        } else {
          this.answers = [];
        }
      });
    },
    onSelect(val) {
      this.selectedanswer = this.answers.filter((c) => c.id === val)[0];
      this.isvalid = true;
    },
  },
  mounted() {
    this.getAnswers();
  },
};
</script>

<style scoped>
/* .el-select-dropdown__item{
  font-size: 18px;
} */
</style>